export var BORDER_RADIUS = 0;
export var DURATION = 300;